import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function PersonProfile({ person, index }) {
  const [open, setOpen] = useState(false);
  const contentId = `bio-${person.id}`;
  const first = person.bio[0];
  const rest = person.bio.slice(1);

  return (
    <article className="border-t border-line pt-10" data-testid={`person-${person.id}`}>
      <div
        className={`grid items-start gap-6 sm:gap-8 ${
          person.portrait ? "sm:grid-cols-[200px_1fr]" : ""
        }`}
      >
        {person.portrait && (
          <img
            src={person.portrait.src}
            alt={person.portrait.alt}
            loading="lazy"
            data-testid={`portrait-${person.id}`}
            className="aspect-[4/5] w-44 rounded-2xl object-cover sm:w-full"
          />
        )}
        <div>
          <h2
            className={
              person.featured
                ? "mt-2 text-2xl font-medium tracking-tight sm:text-3xl"
                : "mt-2 text-xl font-medium tracking-tight sm:text-2xl"
            }
          >
            {person.name}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink/85">{first}</p>
          <div id={contentId} hidden={!open}>
            {rest.map((paragraph, i) => (
              <p key={i} className="mt-5 text-base leading-relaxed text-ink/85">
                {paragraph}
              </p>
            ))}
            {person.link && (
              <p className="mt-5 text-base">
                {person.link.label}:{" "}
                <a
                  href={person.link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`person-link-${person.id}`}
                  className="font-medium text-pine underline decoration-pine/40 underline-offset-4 transition-colors hover:decoration-pine"
                >
                  {person.link.href.replace("https://", "")}
                </a>
              </p>
            )}
          </div>
          <button
            type="button"
            aria-expanded={open}
            aria-controls={contentId}
            onClick={() => setOpen((v) => !v)}
            data-testid={`bio-toggle-${person.id}`}
            className="mt-6 inline-flex items-center gap-2 text-base font-medium text-pine underline-offset-4 transition-colors hover:underline"
          >
            {open ? "Show less" : "Read full biography"}
            <ChevronDown
              className={`h-4 w-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </article>
  );
}
